import { openBlock as t, createElementBlock as c, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M21.5 6.5v11h-19v-11h19Zm-1 1h-17v9h17v-9Z",
  "clip-rule": "evenodd"
}, null, -1), l = /* @__PURE__ */ e("path", { d: "M18.394 12.024c0 .661-.126 1.213-.376 1.656a2.337 2.337 0 0 1-1.04.992c-.448.219-.976.328-1.584.328h-1.848V9.288h1.976c.917 0 1.624.235 2.12.704.501.47.752 1.147.752 2.032Zm-1.6.056c0-1.03-.419-1.544-1.256-1.544h-.448v3.2h.344c.469 0 .813-.136 1.032-.408.218-.272.328-.688.328-1.248ZM8.3 15l-1.17-4.112H7.1c.011.107.022.25.032.432.011.181.022.379.032.592.011.213.016.416.016.608V15H5.811V9.288h2.056l1.192 4.056h.032l1.168-4.056h2.056V15H10.9v-2.504c0-.176.003-.368.008-.576l.016-.584c.011-.187.022-.333.032-.44h-.032L9.771 15H8.3Z" }, null, -1), n = [
  h,
  l
];
function d(r, s) {
  return t(), c("svg", o, [...n]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
